import React, { useEffect, useState, useRef } from 'react';
function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
const features = ['El sistema completo Método Fénix 45+', 'Plantillas de propuestas para clientes', 'Directorio de dónde encontrar clientes digitales', 'Scripts de ventas adaptados a tu perfil', 'Comunidad privada de mujeres Fénix', 'Soporte personalizado durante 30 días'];
export function CTASection() {
  const {
    ref,
    inView
  } = useInView();
  return <section id="cta" className="section-navy py-20 lg:py-28" ref={ref} data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-2">
        {/* Header */}
        <div className="text-center mb-12 transition-all duration-700" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)'
      }} data-id="element-3">
          <p className="font-body font-bold tracking-widest text-sm uppercase mb-3" style={{
          color: '#C9A84C'
        }} data-id="element-4">
            Tu momento es ahora
          </p>
          <h2 className="font-heading font-black mb-4" style={{
          color: '#FAF7F2',
          fontSize: 'clamp(1.8rem, 4vw, 3rem)'
        }} data-id="element-5">
            Recupera Tu Dignidad Financiera
          </h2>
          <p className="font-heading italic text-xl" style={{
          color: '#C9A84C'
        }} data-id="element-6">
            Sin pedir permiso a recursos humanos
          </p>
        </div>

        {/* Pricing card */}
        <div className="max-w-lg mx-auto transition-all duration-700 delay-200" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'scale(1)' : 'scale(0.95)'
      }} data-id="element-7">
          <div className="rounded-2xl overflow-hidden" style={{
          border: '2px solid #C9A84C',
          boxShadow: '0 0 60px rgba(201,168,76,0.2)'
        }} data-id="element-8">
            {/* Card header */}
            <div className="px-8 py-5 text-center" style={{
            backgroundColor: '#C9A84C'
          }} data-id="element-9">
              <p className="font-body font-black text-sm tracking-widest uppercase" style={{
              color: '#0F2540'
            }} data-id="element-10">
                ✦ ACCESO COMPLETO ✦
              </p>
            </div>

            {/* Card body */}
            <div className="px-8 py-8" style={{
            backgroundColor: '#0F2540'
          }} data-id="element-11">
              {/* Price */}
              <div className="text-center mb-8" data-id="element-12">
                <div className="flex items-center justify-center gap-4 mb-2" data-id="element-13">
                  <span className="font-body text-xl line-through opacity-50" style={{
                  color: '#A8C0D8'
                }} data-id="element-14">
                    39€
                  </span>
                  <span className="font-heading font-black" style={{
                  color: '#C9A84C',
                  fontSize: '4rem',
                  lineHeight: 1
                }} data-id="element-15">
                    8,49€
                  </span>
                  <span className="font-body font-black text-sm px-3 py-1 rounded-full" style={{
                  backgroundColor: 'rgba(76, 175, 80, 0.2)',
                  color: '#4CAF50',
                  border: '1px solid rgba(76, 175, 80, 0.4)'
                }} data-id="element-16">
                    -78%
                  </span>
                </div>
                <p className="font-body text-sm" style={{
                color: '#E2C97E'
              }} data-id="element-17">
                  🔥 Precio de lanzamiento · Oferta por tiempo limitado
                </p>
              </div>

              {/* Features */}
              <ul className="space-y-3 mb-8" data-id="element-18">
                {features.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-19">
                    <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-black mt-0.5" style={{
                  backgroundColor: 'rgba(201,168,76,0.2)',
                  color: '#C9A84C'
                }} data-id="element-20">
                      ✓
                    </span>
                    <span className="font-body text-sm" style={{
                  color: '#C8D8E8'
                }} data-id="element-21">
                      {feature}
                    </span>
                  </li>)}
              </ul>

              {/* CTA button */}
              <a href="https://impulsovitaldigital.com/cart/53928761393481:1" target="_blank" rel="noopener noreferrer" className="btn-gold-pulse block w-full py-5 rounded-xl font-body font-black text-base tracking-wide transition-all duration-200 hover:brightness-110 hover:scale-[1.02] text-center no-underline" style={{
              backgroundColor: '#C9A84C',
              color: '#0F2540'
            }} data-id="element-22">
                SÍ, QUIERO REINVENTARME →
              </a>

              {/* Security note */}
              <p className="text-center font-body text-xs mt-4" style={{
              color: '#6A8AAA'
            }} data-id="element-23">
                🔒 Pago seguro · 30 días de garantía total · Sin compromisos
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}